import { createContext, useMemo, useState } from "react";
import {
  InsightsContentData,
  JobPricingContextState
} from "../helpers/models/JobPricingDetailModels";

export const JobPricingContext = createContext({} as JobPricingContextState);

export const JobPricingProvider = ({ children }: any) => {
  const [lineChartRef, setLineChartRef] = useState<Highcharts.Chart | null>(
    null
  );
  const [barChartRef, setBarChartRef] = useState<Highcharts.Chart | null>(null);
  const [insightsContent, setInsightsContent] = useState<InsightsContentData>({
    currentYearData: null,
    previousYearData: null
  });
  const setLineChartReference = (chartRef: Highcharts.Chart) => {
    setLineChartRef(chartRef);
  };
  const setBarChartReference = (chartRef: Highcharts.Chart) => {
    setBarChartRef(chartRef);
  };
  const setInsightsContentData = (data: InsightsContentData) => {
    setInsightsContent(data);
  };

  const providerValues = useMemo(
    () => ({
      lineChartRef,
      barChartRef,
      insightsContent,
      setLineChartReference,
      setBarChartReference,
      setInsightsContentData
    }),
    [lineChartRef, barChartRef, insightsContent]
  );

  return (
    <JobPricingContext.Provider value={providerValues}>
      {children}
    </JobPricingContext.Provider>
  );
};
